import { cn } from '../utils/cn';

export const PersonalizationPlatformIcon = (props: React.ComponentProps<'svg'>) => {
  const { className, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-4', className)}
      {...rest}
    >
      <circle cx="40" cy="40" r="40" fill="#EDFFFA" />
      <circle cx="19" cy="55" r="9" fill="#6FF385" />
      <circle cx="37" cy="55" r="9" fill="#32CC24" />
      <circle cx="55" cy="55" r="9" fill="#186725" />
      <circle cx="37" cy="37" r="9" fill="#8DF38C" />
      <circle cx="55" cy="37" r="9" fill="#5BD770" />
      <circle cx="55" cy="19" r="9" fill="#2AB040" />
    </svg>
  );
};
